<template>
  <div
    class="card-section-cards-view"
    v-loading="loading"
  >
    <component
      v-for="element in elements"
      :is="itemTemplate"
      :key="element.id"
      :element="element"
      :header-fields="headerFields"
      :body-fields="bodyFields"
      :has-error="elementIdsWithErrors.includes(element.id)"
      @elements-changed="$emit('elements-changed')"
    />
    <div
      v-if="!elements.length && !loading"
      class="card-section-cards-view-empty"
    >
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "card-section-cards-view",
  props: {
    elements: {type: Array, default: () => []},
    loading: {type: Boolean, default: false},
    emptyText: {type: String, default: ''},
    headerFields: {type: Array, default: () => []},
    bodyFields: {type: Array, default: () => []},
    itemTemplate: {required: true},
    elementIdsWithErrors: {type: Array, default: () => []},
  },
}
</script>

<style lang="scss">
.card-section-cards-view {
  min-height: 60px;

  &-empty {
    color: #909399;
    text-align: center;
    padding: 24px 0;
  }
}
</style>
